<div class="ui-project__header">
  <h5 class="font-weight-bold mb-0">{{ 'ProjectContacts.title' | translate }}</h5>

  <div class="actions__buttons">
    <app-button
      [permission]="{ group: PermissionsGroups.PROJECT_CONTACTS, action: 'ADD' }"
      (onClick)="addNewContact()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.PRIMARY_BLUE,
        prependSrc: './assets/img/ic-user-plus.svg'
      }"
    />
    <list-search />
    <list-filters-btn-v2 [filters]="ProjectContactsFiltersComponent" />
  </div>
</div>

<div class="container-fluid--30 pt-3 px-0">
  <app-list
    *ngIf="inited"
    [config]="config"
    [emptyTemplate]="emptyTemplate"
    [filters]="ProjectContactsFiltersComponent"
    [searchName]="'ProjectContacts.List.search' | translate"
    [selected]="selected"
    [showToggleMenu]="showToggleMenu.bind(this)"
    #list
  />
</div>

<ng-template #emptyTemplate>
  <app-empty-list
    [imageSrc]="'/assets/img/empty-contacts.svg'"
    [imageAlt]="'ProjectContacts.List.noRecords' | translate"
    [title]="'ProjectContacts.List.emptyTitle' | translate"
    [subtitle]="'ProjectContacts.List.emptyDescription' | translate"
  >
    <app-button
      [permission]="{ group: PermissionsGroups.PROJECT_CONTACTS, action: 'ADD' }"
      (onClick)="addNewContact()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.PRIMARY_BLUE,
        text: 'ProjectTeam.addNewTeamMember' | translate,
        prependSrc: './assets/img/ic-user-plus.svg'
      }"
    />
  </app-empty-list>
</ng-template>

<project-contact-name-cell #projectContactNameCellComponent />
<project-contact-type-cell #projectContactTypeCellComponent />
<project-contact-phone-cell #projectContactPhoneCellComponent />
<project-contact-email-cell #projectContactEmailCellComponent />
<project-contact-function-cell #projectContactFunctionCellComponent />
<project-contact-role-cell #projectContactRoleCellComponent />
